const ITEMS = [
  "SIN MOROSOS",
  "92% COBRADOS EN MENOS DE 48H",
  "RECORDATORIOS AUTOMÁTICOS POR WHATSAPP",
  "SIN COMISIONES OCULTAS",
  "CREADO PARA MYPES LATAM",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee-strip"
    className="relative overflow-hidden border-y border-white/5 bg-[#131316]/60 py-4"
  >
    <div className="animate-marquee flex w-max items-center gap-10">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="mono whitespace-nowrap text-xs uppercase tracking-[0.25em] text-slate-500">
            {item}
          </span>
          <span className="h-1 w-1 rounded-full bg-emerald-500/60" />
        </span>
      ))}
    </div>
  </div>
);
